import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the MymodelProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MymodelProvider {

  constructor() {
  }

  setDataOff(namaData:any, value:any){
    var a = JSON.stringify(value);
    return localStorage.setItem(namaData, a);
  }

  getDataOff(namaData:any){
    return JSON.parse(localStorage.getItem(namaData));
  }

  hapusDataOff(namaData:any){
    return localStorage.removeItem(namaData);
  }

}



// WEBPACK FOOTER //
// ./src/providers/mymodel/mymodel.ts